/**
 * Machine-readable codes the API sends alongside `errorMessage` on a 403 or 409. They exist
 * so the app can respond to *why* a request was refused instead of matching on message text.
 */
export enum EApiErrorCode {
  /** The tenant's plan does not include the requested feature, or a quota is used up. */
  PLAN_UPGRADE_REQUIRED = 'plan_upgrade_required',
  /** 409: a plan change request is already open for this tenant; `ticketNumber` names it. */
  PLAN_CHANGE_ALREADY_REQUESTED = 'plan_change_already_requested',
  TENANT_SUSPENDED = 'tenant_suspended',
  TENANT_DEACTIVATED = 'tenant_deactivated',
  /** The signed-in person has no membership and no usable invitation for this platform. */
  INVITATION_REQUIRED = 'invitation_required',
}

/** Error body shape shared by ErrorHandlingMiddleware and TenantAccessMiddleware. */
export interface IApiError {
  errorMessage?: string;
  errorCode?: EApiErrorCode;
  /** Only with PLAN_CHANGE_ALREADY_REQUESTED: the support case holding the open request. */
  ticketNumber?: number;
}
